"use client";
import {
  useCalendar
} from "./chunk-RKM5FKYF.mjs";
import {
  CalendarBase
} from "./chunk-7FIJ2QLY.mjs";
import {
  CalendarProvider
} from "./chunk-HCKEJHY3.mjs";

// src/calendar.tsx
import { forwardRef } from "@nextui-org/system";
import { jsx } from "react/jsx-runtime";
var Calendar = forwardRef(function Calendar2(props, ref) {
  const { context, getBaseCalendarProps } = useCalendar({ ...props, ref });
  return /* @__PURE__ */ jsx(CalendarProvider, { value: context, children: /* @__PURE__ */ jsx(CalendarBase, { ...getBaseCalendarProps() }) });
});
var calendar_default = Calendar;

export {
  calendar_default
};
